import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "@/lib/api";

const BlogDetail = () => {
  const { slug } = useParams();
  const [post, setPost] = useState(null);

  useEffect(() => {
    api.get("/blogs").then((r) => setPost((r.data || []).find((b) => b.slug === slug) || null));
  }, [slug]);

  if (!post) return <div className="py-40 text-center text-ahm-teal/60">Loading…</div>;

  return (
    <article className="pt-28 md:pt-40 pb-24" data-testid="blog-detail">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <Link to="/blogs" className="text-sm text-ahm-teal/70 hover:text-ahm-orange uppercase tracking-[0.2em]">← All stories</Link>
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-ahm-orange mt-8">{new Date(post.published_at).toLocaleDateString()}</p>
        <h1 className="font-display text-5xl md:text-7xl leading-[0.9] text-ahm-teal mt-4 text-balance">{post.title}</h1>
        <div className="mt-10 aspect-[16/9] rounded-2xl overflow-hidden bg-ahm-muted">
          <img src={post.cover} alt={post.title} className="w-full h-full object-cover" />
        </div>
        <div className="prose prose-lg max-w-none mt-12 space-y-6">
          {(post.blocks || []).map((b, i) => {
            if (b.type === "heading") return <h2 key={i} className="font-display text-3xl md:text-4xl text-ahm-teal mt-10">{b.text}</h2>;
            if (b.type === "paragraph") return <p key={i} className="text-lg leading-relaxed text-ahm-teal/85">{b.text}</p>;
            if (b.type === "image") return <img key={i} src={b.src} alt="" className="rounded-2xl w-full" />;
            return null;
          })}
        </div>
      </div>
    </article>
  );
};

export default BlogDetail;
